import '@/assets/less/noty-overrides.less'
import { noty as _noty, registerNoty } from 'vue-components/plugins/noty/noty'

registerNoty('extension', {
  theme: 'jiminny',
  progressBar: false,
  closeWith: ['button'],
  layout: 'topCenter',
  animation: {
    open: null,
    close: null
  }
})

export default function noty (settings) {
  return _noty('extension', settings)
}



// WEBPACK FOOTER //
// ./src/plugins/noty.js